export const iconFontAwesomeHandsHandPointUp = (
	<i className="fa-solid fa-hand-point-up"></i>
);
